var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.mostrarLoader,"opacity":"0.50","rounded":"sm","spinner-variant":"primary","spinner-type":"grow"}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }